import type { Permission } from '@jecks/shared';
import { cn } from '@jecks/ui';
import { NavLink, Outlet } from 'react-router-dom';
import { useSession } from '@/features/auth/session';

/**
 * Sub-navigation for the stock module — PRD Section 5.6.
 *
 * Suppliers and purchase orders are not linked from here. Stock is set directly on the
 * product, which is all a shop with one warehouse needs. The screens and their routes
 * still exist (`/inventory/suppliers`, `/inventory/purchase-orders`) for the day a shop
 * buys from suppliers on account and wants the weighted-average cost they maintain.
 */
const TABS: Array<{ to: string; label: string; end?: boolean; permission?: Permission }> = [
  { to: '/inventory', label: 'Stock', end: true },
  { to: '/inventory/movements', label: 'Mouvements' },
  { to: '/inventory/counts', label: 'Inventaires' },
  { to: '/inventory/locations', label: 'Emplacements' },
];

export function InventoryLayout() {
  const can = useSession((state) => state.can);
  const visible = TABS.filter((tab) => !tab.permission || can(tab.permission));

  return (
    <div className="flex flex-col gap-5">
      <nav aria-label="Sections du stock" className="-mx-1 overflow-x-auto px-1">
        <div className="flex min-w-max items-center gap-1 border-b border-line">
          {visible.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                cn(
                  'relative whitespace-nowrap px-3 py-2.5 text-sm transition-colors',
                  isActive
                    ? 'text-ink after:absolute after:inset-x-0 after:-bottom-px after:h-0.5 after:bg-brass'
                    : 'text-muted hover:text-ink',
                )
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
      </nav>

      <Outlet />
    </div>
  );
}
